export default __webpack_public_path__ + "static/r-90-1-0f660fbaef8b02874f9ce76f5b99838c.jpg";